import axios from "axios";
import Inputmask from "inputmask";

import Slider from "../templates/blocks/slider/_class";

document.addEventListener('DOMContentLoaded', function () {

    const TRANSITION_SPEED = 450;

    let arPhones = document.body.querySelectorAll('.js-phone');

    const im = new Inputmask("+7 (999) 999-99-99");

    if (arPhones) {

        arPhones.forEach(function (phone) {
            im.mask(phone);
        });

    }

    let arDropdowns = document.body.querySelectorAll('.js-have-dropdown');

    if (arDropdowns) {
        arDropdowns.forEach((link) => {

            let target = document.body.querySelector(link.getAttribute('data-dropdown-id')),
                blurTimeout;

            if (target) {

                let leaveFunction = () => {
                    blurTimeout = setTimeout(() => {
                        link.classList.remove('active');
                        requestAnimationFrame(() => {
                            target.classList.remove('active');
                        });
                        setTimeout(() => {
                            target.style.display = "none";
                        }, 300);
                    }, 300);
                };

                target.addEventListener("mouseenter", function (event) {
                    clearTimeout(blurTimeout);
                });
                link.addEventListener("mouseenter", function (event) {
                    link.classList.add('active');
                    target.style.display = "block";
                    clearTimeout(blurTimeout);
                    setTimeout(() => {
                        requestAnimationFrame(() => {
                            target.classList.add('active');
                        });
                    }, 50);
                }, false);
                link.addEventListener("mouseleave", leaveFunction, false);
                target.addEventListener("mouseleave", leaveFunction, false);
            }

        });
    }

    let arActions = document.body.querySelectorAll('.js-slider');
    if (arActions) {
        arActions.forEach(($slider) => {
            let slider = new Slider($slider, {
                autoplay: {
                    delay: 8500,
                },
                slidesPerView: 1,
                spaceBetween: 30
            });
        });
    }

    let arBrands = document.body.querySelectorAll('.js-brands-slider');
    if (arBrands) {
        arBrands.forEach(($slider) => {
            let slider = new Slider($slider, {
                slidesPerView: 6,
                spaceBetween: 6,
                breakpoints: {
                    // when window width is <= 320px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    // when window width is <= 480px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 6
                    },
                    980: {
                        slidesPerView: 6,
                        spaceBetween: 6
                    }
                }
            });
        });
    }

    let arProducts = document.body.querySelectorAll('.js-products');
    if (arProducts) {
        arProducts.forEach(($slider) => {
            let slider = new Slider($slider, {
                slidesPerView: 3,
                spaceBetween: 30,
                breakpoints: {
                    // when window width is <= 320px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    // when window width is <= 480px
                    640: {
                        slidesPerView: 2.2,
                        spaceBetween: 15
                    }
                }
            });
        });
    }

    let arTogglers = document.body.querySelectorAll('.js-toggler');
    if (arTogglers) {
        arTogglers.forEach(($toggler) => {
            let $target = document.querySelector($toggler.getAttribute('data-target')),
                $parent = document.querySelector($toggler.getAttribute('data-parent'));
            $toggler.addEventListener('click', (event) => {
                event.preventDefault();
                if (!$parent) {
                    $toggler.classList.toggle('active');
                    if ($target) {
                        $target.classList.toggle('show');
                    }
                } else if (!$toggler.classList.contains('active')) {

                    let activeItems = $parent.querySelectorAll('.js-toggler.active');

                    if (activeItems) {
                        activeItems.forEach(($item) => {
                            $item.classList.remove('active');
                            let $target = document.querySelector($item.getAttribute('data-target'));
                            if ($target) {
                                $target.classList.remove('show');
                            }
                        });
                    }

                    $toggler.classList.toggle('active');
                    if ($target) {
                        $target.classList.toggle('show');
                    }
                }

            });
        });
    }

});



// WEBPACK FOOTER //
// ./app.js